import { render, staticRenderFns } from "./Loanable.vue?vue&type=template&id=450f195f"
import script from "./Loanable.vue?vue&type=script&lang=js"
export * from "./Loanable.vue?vue&type=script&lang=js"
import style0 from "./Loanable.vue?vue&type=style&index=0&id=450f195f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports